module.exports = __webpack_public_path__ + "static/image/history/pc/201506@3x.ver2_0_2.jpg?79360ac8";